export default __webpack_public_path__ + "static/media/ic_wmatic_40.47e86bc6.svg";